import {
  CheckBoxTwoTone,
  DirectionsCar,
  Groups2,
  TocTwoTone,
} from "@mui/icons-material";
import { SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";
import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import {
  blueGreyMui,
  deepPurpleMui,
  greyMui,
  MOBILE_BREAKPOINT,
} from "@ryde/theme";

const StatIconsSxDefault: SxProps<Theme> = {
  fontSize: "20px",
  color: greyMui._700,
};

export const PassengerIcon = (): ReactNode => {
  return <Groups2 sx={StatIconsSxDefault} />;
};

export const CarIcon = (): ReactNode => {
  return <DirectionsCar sx={StatIconsSxDefault} />;
};

export const CheckedItemsIcon = (): ReactNode => {
  return <CheckBoxTwoTone sx={StatIconsSxDefault} />;
};

export const TableRowsCountIcon = (): ReactNode => {
  return <TocTwoTone sx={StatIconsSxDefault} />;
};

export const PanelTopRightWrapperStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "panel-top-right-wrapper",
})`
  margin-inline-start: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const PanelStatStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "panel-stat-styled",
})`
  display: flex;
  align-items: center;
  gap: 3px;
  padding-inline-end: 7px;
  padding-inline-start: 5px;
  svg {
    cursor: pointer;
    margin-inline-end: 4px;
  }
  .container_start {
    margin-inline-end: auto;
  }
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    justify-content: flex-start;
    padding-inline-end: 7px;
    min-height: 40px;
    gap: 1px;
    background-color: white;
    border-bottom: 1px solid ${greyMui._300};

    .container_start {
      flex: 1;
      min-width: 0;
      margin-inline-end: 8px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      overflow: hidden;
    }

    .stat_panel_end {
      margin-inline-start: auto;
      flex-shrink: 0;
      display: flex;
      align-items: center;
    }

    &.stat_mobile_align_end {
      justify-content: flex-end;

      .stat_panel_end {
        margin-inline-start: 0;
      }
    }

    &.panel_stat_embedded {
      justify-content: flex-end;
      min-height: unset;
      padding-inline: 0;
      background-color: transparent;
      border-bottom: none;
      width: 100%;
      min-width: 0;
      flex-wrap: nowrap;
      gap: 4px;

      [data-e2e="header-bottom-controls"] {
        flex: 0 0 auto;
        padding-inline-end: 0;
      }

      .stat_panel_end {
        margin-inline-start: 0;
        flex-shrink: 0;
      }
    }
  }
`;

export const ViewSwitchWrapper = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "view-switch-wrapper",
})`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-inline-start: 8px;
  margin-inline-end: 8px;
  svg {
    cursor: pointer;
  }

  .ViewSwitch-ViewIcon {
    color: ${blueGreyMui.A200};
  }

  &.ViewSwitch_Page_GridMultiSelect .ViewSwitch-TableViewIcon,
  &.ViewSwitch_Page_GridSingleSelect .ViewSwitch-GridSingleSelectIcon,
  &.ViewSwitch_Page_Kanban .ViewSwitch-KanbanIcon,
  &.ViewSwitch_Page_CardBoard .ViewSwitch-CardBoardIcon {
    color: ${deepPurpleMui.A700};
  }
`;
